import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ConfirmDialog } from "security-app/components/common/Modal";
import List from "./List";
const UsersModal = ({
  closeModal,
  confirmDisabled,
  isLoading = false,
  onConfirm,
  owner = void 0,
  show = false
}) => {
  const { t } = useTranslation("enterprise_security_events");
  const [ownerId, setOwnerId] = useState(owner);
  const _onConfirm = useCallback(() => onConfirm(ownerId), [onConfirm, ownerId]);
  useEffect(() => {
    setOwnerId(owner);
  }, [show]);
  const assignText = ownerId ? t("users_modal.assign_new_owner") : t("users_modal.remove_owner");
  return /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show,
      onConfirm: _onConfirm,
      confirmDisabled,
      isLoading,
      confirmText: assignText,
      onCancel: closeModal,
      title: t("users_modal.title")
    },
    /* @__PURE__ */ React.createElement(List, { ownerId, setOwnerId })
  );
};
export default UsersModal;
